export default class Rule {
    constructor(rule = {}) {
        this.ruleId = rule.id;
        this.name = rule.name
    }
}